module.exports = __webpack_public_path__ + "static/media/Design Spec.074ca04a.png";